import Vue from 'vue'
import {trackPageView} from './trace'
import {getUserClassId, classUserPermissions, getUserPerss, joinClassRoom} from '../api/grade'
import {Toast, Dialog} from 'vant'
// import {PEROLES, CDROLES} from '@/utils/configRoles.js'
import routerJS from '@/router/index'
import {nanoid} from 'nanoid'
import { USER_INFO } from '@/store/mutation-types'

// 获取地址栏参数，name:参数名称
export function getUrlParms(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}

// 生成路由
export function generateRouter(data) {
  return generateChildRouters(data)
}

// 检测是否为空对象
export function checkObject(obj) {
  if (Object.prototype.toString.call(obj) === '[object Object]') {
    const arr = Object.keys(obj)
    if (arr.length > 0) {
      return true
    } else {
      return false
    }
  } else {
    return false
  }
}

export function numToCapital(num, type = '') {
  if (!num) return 0
  const strNum = Number((num + '').replace(/[,，]*/g, '')) + '' // 记录字符
  num = parseInt(Number(strNum)) // 转为整数，
  let capitalAr = '零一二三四五六七八九十'
  let unitAr = ['十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千']
  if (type) {
    capitalAr = '零壹贰叁肆伍陆柒捌玖拾'
    unitAr = ['拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟'] // 单位
  }
  const resultAr = [] // 记录结果，后边json.in就可
  let index = strNum.length - 1 // 记录位数
  let idx = 0 // 记录单位
  let percent = 10
  const turnNum = (num, percent, index) => {
    const unit = num / percent
    const capital = capitalAr[Number(strNum[index])]
    if (unit < 1) {
      resultAr.push(capital)
      // 出现11【一十一】这种情况
      if (Number(strNum[index]) === 1 && (strNum.length === 2 || strNum.length === 6 || strNum.length === 10)) {
        resultAr.pop()
      }
      return false // 结束递归
    } else {
      if (capital === '零') {
        // 万和亿单位不删除
        if (!['万', '亿'].includes(resultAr[resultAr.length - 1])) {
          resultAr.pop()
        }
        // 前面有零在删掉一个零
        if (resultAr[resultAr.length - 1] === '零') {
          resultAr.pop()
        }
      }
      resultAr.push(capital)
      // 过滤存在【零万】【零亿】这种情况
      if (['万', '亿'].includes(resultAr[resultAr.length - 2]) && capital === '零') {
        resultAr.pop()
      }
      // 过滤【1亿万】这种情况
      if (resultAr[0] === '万' && resultAr[1] === '亿') {
        resultAr.shift()
      }
      // 末尾【零】删掉
      if (resultAr[0] === '零') {
        resultAr.pop()
      }
      resultAr.push(unitAr[idx++])
      turnNum(num, percent * 10, --index)
    }
  }
  turnNum(num, percent, index)
  return resultAr.reverse().join('')
}

// 拆分数组
// subGroupLength每组数组多少个，如：10
// array需要拆分的数组
export function splitArray(array, subGroupLength) {
  let index = 0
  let newArray = []
  while (index < array.length) {
    newArray.push(array.slice(index, index += subGroupLength))
  }
  return newArray
}

// 阿拉伯数字转中文数字
export function NoToChinese(num) {
  if (!/^\d*(\.\d*)?$/.test(Number(num))) {
    // alert('Number is wrong!')
    return num
  }
  let AA = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  let BB = ['', '十', '百', '千', '万', '亿', '点', '']
  let a = ('' + num).replace(/(^0*)/g, '').split('.')
  let k = 0
  let re = ''
  for (let i = a[0].length - 1; i >= 0; i--) {
    switch (k) {
      case 0:
        re = BB[7] + re
        break
      case 4:
        if (!new RegExp('0{4}\\d{' + (a[0].length - i - 1) + '}$').test(a[0])) {
          re = BB[4] + re
        }
        break
      case 8:
        re = BB[5] + re
        BB[7] = BB[5]
        k = 0
        break
    }
    if (k % 4 === 2 && a[0].charAt(i + 2) !== 0 && a[0].charAt(i + 1) === 0) {
      re = AA[0] + re
    }
    if (a[0].charAt(i) !== 0) {
      re = AA[a[0].charAt(i)] + BB[k % 4] + re
      k++
    }
  }
  // 加上小数部分(如果有小数部分)
  if (a.length > 1) {
    re += BB[6]
    for (let j = 0; j < a[1].length; j++) re += AA[a[1].charAt(j)]
  }
  return re
}

// 数字转中文
export function numberToChinese(input) {
  // 1. 统一转成 number
  if (typeof input === 'string') {
    // 去掉空格、千分位逗号
    input = input.trim().replace(/,/g, '')
  }

  const num = Number(input)

  if (isNaN(num)) return ''
  if (num === 0) return '零'

  const CN_NUM = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const CN_UNIT = ['', '十', '百', '千']
  const CN_SECTION = ['', '万', '亿', '兆']

  let integerPart = Math.floor(num)
  let decimalPart = num.toString().split('.')[1]

  function sectionToChinese(section) {
    let str = ''
    let unitPos = 0
    let zero = true

    while (section > 0) {
      const v = section % 10
      if (v === 0) {
        if (!zero) {
          zero = true
          str = CN_NUM[0] + str
        }
      } else {
        zero = false
        str = CN_NUM[v] + CN_UNIT[unitPos] + str
      }
      unitPos++
      section = Math.floor(section / 10)
    }
    return str
  }

  let chineseStr = ''
  let sectionPos = 0
  let needZero = false

  while (integerPart > 0) {
    const section = integerPart % 10000
    if (section === 0) {
      if (needZero) {
        chineseStr = CN_NUM[0] + chineseStr
        needZero = false
      }
    } else {
      chineseStr =
        sectionToChinese(section) +
        CN_SECTION[sectionPos] +
        chineseStr
      needZero = true
    }
    sectionPos++
    integerPart = Math.floor(integerPart / 10000)
  }

  // 2. 处理小数
  if (decimalPart) {
    chineseStr += '点'
    for (const char of decimalPart) {
      chineseStr += CN_NUM[char]
    }
  }

  // 3. 修正“一十” → “十”
  chineseStr = chineseStr.replace(/^一十/, '十')

  return chineseStr
}

function generateChildRouters(data, type, moduleName) {
  let routers = []
  let components = []
  for (let item of data) {
    if (item.type === '1' || item.type === '3') {
      let componentPath = resolve => require(['@/views/' + item.component + '.vue'], resolve)
      let menu = {
        path: (type === 'children' ? '' : '/') + item.path,
        name: item.name,
        icon: item.icon,
        redirect: item.redirect,
        component: componentPath,
        hidden: item.hidden !== 0,
        meta: {
          moduleName: moduleName || item.name
        }
      }
      if (item.children && item.children.length > 0) {
        menu.children = [...generateChildRouters(item.children, 'children', item.name).routers]
      }
      routers.push(menu)
    } else if (item.type === '2') {
      if (item.children && item.children.length > 0) {
        let menu = generateChildRouters(item.children, '', item.name).routers
        routers = routers.concat(menu)
      }
    }
    if (item.type === '4') {
      components.push(item.component)
    }
  }
  return {
    routers,
    components
  }
}

/*
* 替换url的参数值
* url 目标url
* arg 参数
* argVal 参数值
* return url 参数替换后的url
*/
export function replaceUrlParam(url, arg, argVal) {
  // 匹配参数和参数值的正则
  // var reg = /([^?&])+(=)([^&])+/g;
  // var pattern = eval(`/([\?|\&])(${arg}=)([^&]+)/gi`);
  // eslint-disable-next-line no-useless-escape
  let pattern = new RegExp(`([\?|\&])(${arg}=)([^&]+)`, 'ig')
  let replaceText = arg + '=' + argVal
  return url.match(pattern)

    ? url.replace(pattern, `$1${replaceText}`)

    : url.match('[?]')

      ? url + '&' + replaceText

      : url + '?' + replaceText
}

export function setSha(txt) {
  let sha256 = require('js-sha256').sha256 // 这里用的是require方法，所以没用import
  return `&xxbtoken=${sha256(txt).toLocaleUpperCase()}` // 要加密的内容
}

function getWapUserInfo () {
  return Vue.ls.get(USER_INFO) || null
}

/** WAP 跳转：微信 openid / unionid 绑定参数 */
export function buildWapOpenidBindli () {
  const info = getWapUserInfo()
  if (!info) return ''
  return `&unionid=${info.unionId}&openid=${info.iepOpenId}${setSha(`xxbiep${info.iepOpenId}`)}&iepUserId=${info.id}`
}

// 节流
export function throttle(fn, delay) {
  let valid = true
  return function () {
    if (valid) { // 如果阀门已经打开，就继续往下
      setTimeout(() => {
        fn.apply(this, arguments)// 定时器结束后执行
        valid = true// 执行完成后打开阀门
      }, delay)
      valid = false// 关闭阀门
    }
  }
}

// 刚开始valid为true，然后将valid重置为false,进入了定时器，在定时器的时间期限之后，才会将valid重置为true,valid为true之后，之后的点击才会生效
// 在定时器的时间期限内，valid还没有重置为true，会一直进入return，就实现了在N秒内多次点击只会执行一次的效果

// 用法：
// function fn(value){
//   console.log(value);
// }
// var throttleFunc = throttle(fn,2000);//节流函数
//  //事件处理函数，按钮点击事件
// btn.addEventListener("click",function(){
//     throttleFunc(Math.random());// 给节流函数传参
// })
// 防抖
export function debounce(fn, delay) {
  let timer = null
  return function () {
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, arguments)
    }, delay)
  }
}

// 获取url中"?"符后的字串
export function getParamByUrl(url) {
  var theRequest = {}
  var index = url.indexOf('?')
  if (index !== -1) {
    let str = url.substr(index + 1)
    let strs = str.split('&')
    for (var i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = (strs[i].split('=')[1])
    }
  }
  return theRequest
}

// 禁止滚动
export function stopScroll() {
  var mo = function (e) {
    e.preventDefault()
  }

  document.body.style.overflow = 'hidden'
  document.body.style.height = '100vh'
  document.addEventListener('touchmove', mo, false)// 禁止页面滑动
}

export const setLoginFrontId = () => {
  const uuid = nanoid()
  localStorage.setItem('loginFrontId', uuid)
  return uuid
}

export const getLoginFrontId = () => localStorage.getItem('loginFrontId')

/**
 * 微信授权跳转
 * 前端直接构造微信授权URL并跳转，不再经过后端 /openapi/iep/login
 * @param {string} targetPath - 授权成功后要跳转的目标路径（可选，默认使用当前路径）
 */
export const redirectToWxAuth = (targetPath) => {
  const appId = process.env.wxAppId
  // 获取当前域名
  const host = window.location.origin

  // 确定授权后要跳转的目标路径
  let redirectPath = targetPath || `${window.location.pathname}${window.location.search}`

  // 病例社区回跳：能从入参 / 当前链接解到 shareUrl、csReturn、backurl 就先写入，和 redirectURL 同一时机
  cacheCasesharingRedirectFromAuth(targetPath)

  const bingliUrl = process.env.bingliUrl || ''
  const isCasesharingTarget = bingliUrl && redirectPath.indexOf(bingliUrl) === 0
  // 排除不需要缓存的路径（注册页不能覆盖已保存的业务目标页）
  if (!isCasesharingTarget && redirectPath.indexOf('longTimeLogin') < 0 && redirectPath.indexOf('loginPage') < 0 && redirectPath.indexOf('/register') < 0) {
    window.localStorage.setItem('redirectURL', redirectPath)
  }

  // 后端需要的地址，最后还是会重定向到loginPage页面
  const backurl = `${host}/home?id=${setLoginFrontId()}`

  // 构造微信授权回调地址（后端接口地址）
  const redirectUri = `${host}/openapi/hyd/oauth/redirect?backurl=${btoa(backurl)}`

  // 构造微信授权URL
  const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
  window.location.href = authUrl
}

function normalizeBase64(str) {
  return String(str || '').replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, '')
}

function decodeBase64Safe(str) {
  const s = normalizeBase64(str)
  if (!s) return ''
  const pad = s.length % 4
  const padded = pad ? s + '===='.slice(0, 4 - pad) : s
  return window.atob(padded)
}

function decodeCsReturnValue(val) {
  let raw = String(val || '').replace(/ /g, '+')
  for (let i = 0; i < 2; i++) {
    if (raw.indexOf('%') < 0) break
    try {
      raw = decodeURIComponent(raw)
    } catch (e) {
      break
    }
  }
  if (raw.indexOf('http://') === 0 || raw.indexOf('https://') === 0 || raw.indexOf('/') === 0 || raw.indexOf('#') === 0) {
    return raw
  }
  try {
    return decodeBase64Safe(raw)
  } catch (e) {
    return raw
  }
}

function decodeIepBackurlString(backurl) {
  try {
    return decodeBase64Safe(backurl)
  } catch (e) {}
  try {
    return decodeBase64Safe(decodeURIComponent(backurl))
  } catch (e2) {}
  return String(backurl || '')
}

function toCasesharingRedirectUrl(raw) {
  const bingliUrl = (process.env.bingliUrl || '').replace(/\/$/, '')
  if (!raw || !bingliUrl) return ''
  const url = decodeCsReturnValue(raw)
  if (!url) return ''
  if (url.indexOf(bingliUrl) === 0) return url
  if (url.indexOf('/') === 0) return bingliUrl + url
  if (url.indexOf('#') === 0) return bingliUrl + '/wap/index.html' + url
  return ''
}

// 从 Java 回传的 backurl 取出病例社区原页（优先 csReturn，没有则用 shareUrl）
export function extractCasesharingReturnUrl(iepLoginResult) {
  if (!iepLoginResult || !iepLoginResult.backurl) return ''
  const decoded = decodeIepBackurlString(iepLoginResult.backurl)
  const match = decoded.match(/[?&]csReturn=([^&]*)/) || decoded.match(/[?&]shareUrl=([^&]*)/)
  if (!match) return ''
  return toCasesharingRedirectUrl(match[1])
}

// 授权前写入：当前页 query 或传入的病例社区地址
export function cacheCasesharingRedirectFromAuth(targetPath) {
  const fromTarget = toCasesharingRedirectUrl(targetPath)
  if (fromTarget) {
    localStorage.setItem('casesharingRedirectURL', fromTarget)
    return true
  }
  const fromCsReturn = toCasesharingRedirectUrl(getUrlParms('csReturn'))
  if (fromCsReturn) {
    localStorage.setItem('casesharingRedirectURL', fromCsReturn)
    return true
  }
  const fromShareUrl = toCasesharingRedirectUrl(getUrlParms('shareUrl'))
  if (fromShareUrl) {
    localStorage.setItem('casesharingRedirectURL', fromShareUrl)
    return true
  }
  const backurl = getUrlParms('backurl')
  if (backurl) {
    const fromBackurl = extractCasesharingReturnUrl({ backurl })
    if (fromBackurl) {
      localStorage.setItem('casesharingRedirectURL', fromBackurl)
      return true
    }
  }
  return false
}

// 90 天验证前补写。Java 已注册会删 shareUrl，解不到时不要清掉授权前已写入的值
export function saveCasesharingReturnFromBackurl(iepLoginResult) {
  const storageKey = 'casesharingRedirectURL'
  const url = extractCasesharingReturnUrl(iepLoginResult)
  if (url) {
    localStorage.setItem(storageKey, url)
    return
  }
  const bingliUrl = (process.env.bingliUrl || '').replace(/\/$/, '')
  const decoded = iepLoginResult && iepLoginResult.backurl ? decodeIepBackurlString(iepLoginResult.backurl) : ''
  const isCasesharingCallback = !!(decoded && bingliUrl && decoded.indexOf(bingliUrl) === 0)
  if (!isCasesharingCallback) {
    localStorage.removeItem(storageKey)
  }
}

/** *允许滚动***/

export function canScroll() {
  var mo = function (e) {
    e.preventDefault()
  }

  document.body.style.overflow = ''// 出现滚动条
  document.body.style.height = '100%'
  var htmlElement = document.documentElement
  htmlElement.style.overflow = ''
  document.removeEventListener('touchmove', mo, false)
}

export function distanceOpenTime(showTime) {
  // let timer = showTime
  const currentTime = new Date()
  const targetTime = new Date(showTime)
  // 计算时间差（以毫秒为单位）
  const timeDiff = targetTime.getTime() - currentTime.getTime()
  // 将时间差转换为小时、分钟和秒数
  const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24))
  const hours = Math.floor(timeDiff / (1000 * 60 * 60) % 24)
  // const minutes = Math.floor((timeDiff / (1000 * 60)) % 60)
  // const seconds = Math.floor((timeDiff / 1000) % 60)
  let ret = days >= 0 ? `${days} 天 ${hours} 小时` : '已过期'
  return ret
}

export function updateQueryParam(url, paramName, newValue) {
  try {
    // 解析当前URL
    const currentUrl = new URL(url)
    const searchParams = currentUrl.searchParams

    // 更新或设置指定的参数值
    searchParams.set(paramName, newValue)

    // 更新URL的搜索字符串
    currentUrl.search = searchParams.toString()

    // 返回更新后的URL
    return currentUrl.toString()
  } catch (error) {
    console.error('Invalid URL:', error)
    return url // 如果URL无效，返回原始URL
  }
}

export function modifyURLParam(url, paramName, paramValue) {
  var urlParts = url.split('?')
  var urlBase = urlParts[0]
  var queryString = urlParts[1]
  if (!queryString) {
    return urlBase + '?' + paramName + '=' + encodeURIComponent(paramValue)
  }
  var re = new RegExp('([?&])' + paramName + '=.*?(&|$)', 'i')
  if (url.match(re)) {
    return url.replace(re, '$1' + paramName + '=' + encodeURIComponent(paramValue) + '$2')
  } else {
    return `${urlBase}?${queryString}&${paramName}=${encodeURIComponent(paramValue)}`
  }
}

export function traceClickURL() {
  let pathToFrom = JSON.parse(localStorage.getItem('vmPathToFrom'))
  let startTime = JSON.parse(localStorage.getItem('startTime'))
  trackPageView(pathToFrom.to, pathToFrom.from, startTime)
}

export function uniqueCourses(courses) {
  const seenIds = new Set()
  return courses.filter(course => {
    // 确定使用哪个 ID 字段
    const id = course.courseId ? course.courseId : course.id
    // 如果 ID 不存在于集合中，则添加并返回 true，否则返回 false
    if (!seenIds.has(id)) {
      seenIds.add(id)
      return true
    }
    return false
  })
}

export function uniqueActivity(activity) {
  const seenIds = new Set()
  return activity.filter(item => {
    if (!seenIds.has(item.seepCode)) {
      seenIds.add(item.seepCode)
      return true
    }
    return false
  })
}

export async function handleRoute(to, next, userInfo) {
  const managePath = ['/createGrade', '/selectMember', '/gradeCode', '/selectAdmin', '/createGradeSucc', '/gradeInterpage', '/selectGroupList', '/gradeGroup', '/courseSchedule']
  let path = to.path
  let query = {...to.query}
  let hasBeenCalled = false
  let manageRoles = []
  if (sessionStorage.getItem('gradeRolesList')) {
    const ADMINROLES = JSON.parse(`${sessionStorage.getItem('gradeRolesList')}`).ADMINROLES
    const EDITORROLES = JSON.parse(`${sessionStorage.getItem('gradeRolesList')}`).EDITORROLES
    manageRoles = [...ADMINROLES, ...EDITORROLES]
  }
  sessionStorage.removeItem('gradeUserPermissions')

  async function completeNavigation() {
    if (hasBeenCalled) return
    hasBeenCalled = true
    sessionStorage.setItem('isGradeCheck', 'true')
    // 只有当路径或查询参数发生变化时，才调用 next({ path, query })
    if (path !== to.path || JSON.stringify(query) !== JSON.stringify(to.query)) {
      next({path, query})
    } else {
      next()
    }
  }

  try {
    if (userInfo.memberType == 1) { // 员工
      let userRole = await getUserPerss(userInfo.id)
      sessionStorage.setItem('gradeUserPermissions', JSON.stringify(userRole.data))

      if (managePath.includes(to.path) && to.query && to.query.sourceShare) {
        if (manageRoles.includes(userRole.data)) {
          path = '/grade'
        } else {
          Toast('暂无权限，返回iEP主页')
          path = '/home'
        }
        setTimeout(completeNavigation, 1500)
        return
      }

      if (to.query && to.query.classId) {
        const params = {classId: to.query.classId, userId: userInfo.id}
        const {data} = await classUserPermissions(params)

        if (data.inClassList) {
          if ([1, 2].includes(data.roleType)) {
            data.isAddBBS = true
            data.isAdminPermiss = true
            data.isJourneyEdit = true
          }
          // } else if (CDROLES.includes(userRole.data) && data.isManage) {
          //   data.isJourneyEdit = true // 编辑课程
        }

        sessionStorage.setItem('classPermissions', JSON.stringify(data))
        query = {...to.query, classId: data.classId}
      }

      completeNavigation()
    } else if (userInfo.memberType == 0) { // 术者
      let isWhiteUser = JSON.parse(sessionStorage.getItem('isWhiteUser'))
      if ((managePath.includes(to.path) || to.path === '/grade') && !isWhiteUser) {
        Toast('暂无权限，返回iEP主页')
        path = '/home'
        setTimeout(completeNavigation, 1500)
        return
      }

      const userClasses = await getUserClassId(userInfo.id)

      if (userClasses.data && userClasses.data.length > 0) {
        if (to.query.classId && to.query.classId !== userClasses.data) {
          Toast('已为您跳转到您的班级主页')
          path = '/gradeHomePage'
          query = {classId: userClasses.data}
          setTimeout(completeNavigation, 1000)
          return
        }

        const params = {classId: userClasses.data, userId: userInfo.id}
        const {data} = await classUserPermissions(params)

        if (data.inClassList && data.userStatus === 1 && data.roleType === 3) {
          data.isAddBBS = true
          data.commonPer = true
        }

        sessionStorage.setItem('classPermissions', JSON.stringify(data))

        if (data.inClassList && data.userStatus === 1) {
          // 存在班级 && 已加入
        } else if (data.userStatus === 2) {
          // 存在班级 && 没有加入 直接进入已加入的班级主页
          path = '/gradeHomePage'
          query = {classId: userClasses.data}
        } else if (to.query && to.query.classId && `${to.query.classId}` !== `${data.classId}`) {
          await Dialog.alert({
            title: '提示',
            message: '您目前不在该班级成员名单内，暂不能加入,如有需要请联系强生员工。',
            confirmButtonText: '关闭',
            className: 'default-alert default-confirm-dialog'
          }).then(() => {
            path = '/home'
            completeNavigation()
          })
          return
        } else {
          await Dialog.confirm({
            title: '提示',
            message: `您已被邀请到${data.className}班级，但还没加入是否需要加入！`,
            confirmButtonText: '加入',
            cancelButtonText: '回首页',
            className: 'default-confirm-dialog'
          })
            .then(() => {
              // on confirm
              const joinParams = {classId: userClasses.data, userId: userInfo.id}
              joinClassRoom(joinParams).then(res => {
                if (res.code === 0) {
                  Toast('您已加入班级，正在为您跳到班级主页')
                  path = to.query && to.query.classId && to.query.classId === userClasses.data ? to.path : '/gradeHomePage'
                  query = to.query ? Object.assign(to.query, {classId: userClasses.data}) : {classId: userClasses.data}
                  setTimeout(completeNavigation, 1500)
                }
              })
            })
            .catch(() => {
              path = '/home'
              completeNavigation()
            })
          return
        }
      } else if (!isWhiteUser) {
        Toast(to.query.classId ? '您还未加入特定班级，请等待管理员为您进行班级配置' : '暂无班级权限，已为您跳转至iEP首页。')
        path = '/home'
        setTimeout(completeNavigation, 1500)
        return
      }

      completeNavigation()
    }
  } catch (error) {
    console.error('Error handling route:', error)
    path = '/home'
    setTimeout(completeNavigation, 1500)
  }
}

// 不管什么日期格式，都转成时间戳
export function toTimestamp(startTime) {
  // 如果输入的是数值型的时间戳（可能是字符串类型的数字）
  if (!isNaN(startTime)) {
    return parseInt(startTime, 10) // 返回时间戳数字
  }

  // 如果是普通的日期字符串格式，例如 '2025-02-14 17:10'
  const parsedTime = new Date(startTime.replace(/-/g, '/')) // 替换 '-' 为 '/'，兼容部分浏览器解析
  if (!isNaN(parsedTime.getTime())) {
    return parsedTime.getTime() // 返回时间戳数字
  }

  throw new Error('Invalid date format')
}

export const pollingPath = ['/articleDetails', '/pdfView', '/dccDetail', '/technologyDetail', '/JJMC_ECGenius', '/topicDetail', '/kdSimulator', '/filePreview']
export const entranceFromPath = ['/courserDetails', '/scormCourseDetail', '/dailyDetails', '/articleDetails', '/questionnaire', '/liveDetails', '/trainingCampDetails', '/annualReport', '/journalArticle', '/pfa', '/pfa2', '/caseReview']
export const entranceToPath = ['/articleDetails', '/courserDetails', '/scormCourseDetail', '/liveDetails', '/annualReport', '/journalArticle', '/pfa', '/pfa2', '/caseReview']
export const judgePath = ['/longTimeLogin', '/register', '/agree', '/loginVerification', '/appealPage', '/sso/tempPage', '/linkExpired']

/**
 * 术者认证状态
 * 认证中:
 * 有效: 300、有效
 * 无效 "400", "-300", "无效", "不确定"
 */
export const veevaStatusSuccess = ['300', '有效']
export const veevaStatusFail = ['400', '-300', '无效', '不确定']

export const getUserIdentity = () => {
  try {
    const loginResult = sessionStorage.getItem('iepLoginResult')
    if (!loginResult) {
      return undefined
    }
    const {userIdentity} = JSON.parse(loginResult)
    if (userIdentity) {
      let disableDateValue
      try {
        if (userIdentity.memberType == 0) {
          disableDateValue = userIdentity.hcpDisableDate
        } else if (userIdentity.memberType == 1) {
          disableDateValue = userIdentity.employeeDisableDate
        }

        // '', null, undefined 视为未过期
        if (disableDateValue == null || disableDateValue === '') {
          return Object.assign({}, userIdentity, {
            isDueDate: false
          })
        }

        const dueDate = new Date(disableDateValue)
        const dueDateTime = isNaN(dueDate.getTime()) ? 0 : dueDate.getTime()

        return Object.assign({}, userIdentity, {
          isDueDate: Date.now() > dueDateTime
        })
      } catch (error) {
        // 处理日期转换异常
        return Object.assign({}, userIdentity, {
          isDueDate: false
        })
      }
    }
  } catch (error) {
    // JSON解析失败或其他异常情况
    return undefined
  }
}

/**
 * 将 HH:MM:SS 格式的时间转换为秒数
 * @param {string} timeString - 时间字符串，格式为 HH:MM:SS
 * @returns {number} 总秒数
 */
export function timeToSeconds(timeString) {
  const parts = timeString.split(':')
  if (parts.length !== 3) {
    throw new Error('时间格式错误，应为 HH:MM:SS')
  }

  const hours = parseInt(parts[0], 10)
  const minutes = parseInt(parts[1], 10)
  const seconds = parseInt(parts[2], 10)

  return hours * 3600 + minutes * 60 + seconds
}

export function beforeLoginFun() {
  const loginResult = sessionStorage.getItem('iepLoginResult')
  if (!loginResult) return
  const {backurl, isUserInfo, urlType, isAgree, isLogin, userIdentity} = JSON.parse(loginResult)
  const redirectURL = window.localStorage.getItem('redirectURL') || ''
  const isInformationDisplay = window.location.pathname.includes('/informationDisplay') || redirectURL.includes('/informationDisplay')
  if (isInformationDisplay) {
    // 路径来自缓存时转存到 session，避免关闭页面后反复命中老的 redirectURL
    if (redirectURL) {
      window.localStorage.removeItem('redirectURL')
    }
    // alert展示个人信息
    window.alert(JSON.parse(loginResult).openId)
  }

  /**
   * 判断是否需要进入身份识别页面
   * 不在白名单中
   *
   * 离职员工:
   * 正式禁用前14天内
   * 正式禁用后
   *
   * 无效术者
   * 正式禁用前14天内, 未发起认证/认证失败
   * 正式禁用后, 未发起认证/认证失败
   */
  if (userIdentity && userIdentity.isJudge) {
    routerJS.push({path: 'loginVerification'})
    return false
  }

  // 长时间未登录
  if (`${isLogin}` === '0') {
    routerJS.push({path: 'longTimeLogin'})
    return false
  }

  // 六字段缺失
  if (`${isUserInfo}` === '0') {
    routerJS.push({
      path: 'register',
      query: {isEidt: true, backurl, type: 'complement'}
    })
    return false
  }
  // 是否隐私授权
  if (`${isAgree}` === '0') {
    routerJS.push({
      path: 'agree',
      query: {backurl, isUserInfo, isAgree}
    })
    return false
  }

  // 跳转
  if (`${urlType}` === '2' && backurl) {
    window.location.href = atob(backurl)
    return false
  }

  // if (backurl) {
  //   window.location.href = atob(backurl)
  //   return false
  // } else
  if (!window.location.href.includes('/register') && !window.location.href.includes('/loginPage')) {
    routerJS.push({path: 'home'})
  }

  return true
}

export default {
  getUrlParms,
  generateRouter,
  checkObject,
  splitArray,
  numToCapital,
  NoToChinese,
  replaceUrlParam,
  setSha,
  throttle,
  debounce,
  getParamByUrl,
  distanceOpenTime,
  updateQueryParam,
  modifyURLParam,
  uniqueCourses,
  uniqueActivity,
  pollingPath,
  entranceFromPath,
  entranceToPath,
  judgePath,
  toTimestamp,
  numberToChinese,
  redirectToWxAuth,
  cacheCasesharingRedirectFromAuth,
  saveCasesharingReturnFromBackurl,
}



// WEBPACK FOOTER //
// ./src/utils/util.js